import axios from "axios";
import { BASE_URL } from "App/constants";
import { GetReviewerCoachesResponse } from "Interfaces/Pages/AssetReviewRequestsInterface";
import {
  GetAssetReviewRequestsParams,
  GetAssetReviewRequestsResponse,
} from "Interfaces/Pages/AssetReviewRequestsInterface";

export const getAssetReviewRequests = async (
  params: GetAssetReviewRequestsParams
): Promise<GetAssetReviewRequestsResponse> => {
  const {
    page,
    perPage,
    search,
    status,
    order_by,
    order_type,
    unpaid_first,
    coach_id,
    requestor_id,
    requestor_type,
  } = params;

  const { data } = await axios.get(`${BASE_URL}asset_review_requests`, {
    params: {
      page,
      per_page: perPage,
      search,
      status,
      order_by,
      order_type,
      unpaid_first,
      coach_id,
      requestor_id,
      requestor_type,
    },
  });

  return data as GetAssetReviewRequestsResponse;
};

export const getReviewerCoaches = async (
  masterSportId: number,
  searchInput: string = "",
  page: number = 1,
  perPage: number = 20
): Promise<GetReviewerCoachesResponse> => {
  type ReviewerCoachesQueryParams = {
    requested_as_reviewer: boolean;
    search: string;
    page: number;
    per_page: number;
    master_sport_id?: number;
  };

  const params: ReviewerCoachesQueryParams = {
    requested_as_reviewer: true,
    search: searchInput,
    page,
    per_page: perPage,
  };
  // Only include master_sport_id if it's a valid number > 0
  if (masterSportId && masterSportId > 0) {
    params.master_sport_id = masterSportId;
  }

  const { data } = await axios.get(`${BASE_URL}coaches`, { params });

  return data as GetReviewerCoachesResponse;
};

export const reassignReviewRequest = async (
  reviewRequestId: number,
  coachId: number
) => {
  const { data } = await axios.patch(
    `${BASE_URL}asset_review_requests/${reviewRequestId}`,
    {
      asset_review_request: {
        coach_id: coachId,
      },
    }
  );

  return data;
};

export const getAssetReviewRequestById = async (id: number) => {
  const { data } = await axios.get(`${BASE_URL}asset_review_requests/${id}`);
  return data;
};

export const patchAssetReviewRequestPaidStatus = async (
  id: number,
  paidStatus: boolean
) => {
  const { data } = await axios.patch(`${BASE_URL}asset_review_requests/${id}`, {
    asset_review_request: {
      coach_paid: paidStatus,
    },
  });
  return data;
};

export const getKpointHighlights = async (
  assetId: number,
  reviewRequestId: number,
  page: number,
  perPage: number = 10
) => {
  const { data } = await axios.get(
    `${BASE_URL}assets/${assetId}/kpoint_highlights`,
    {
      params: {
        asset_review_request_id: reviewRequestId,
        page,
        per_page: perPage,
      },
    }
  );
  return data as {
    data: Array<{
      id: number;
      highlight: string;
      start_milliseconds: number;
      end_milliseconds: number;
      kpoint_highlight_id: string;
      asset_id: number;
      asset_review_request_id: number | null;
      author: { id: number; name: string };
    }>;
    total_count: number;
  };
};

export const patchMarkBulkPayment = async (
  ids: number[],
  coachPaid: boolean
) => {
  const { data } = await axios.patch(
    `${BASE_URL}asset_review_requests/mark_bulk_payment`,
    {
      asset_review_requests: {
        ids,
        coach_paid: coachPaid,
      },
    }
  );
  return data;
};
